import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';
 
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-wave"></div>
      <div className="footer-content">
        <div className="footer-column">
          <h3>About Us</h3>
          <p>Vardaan Resources Private Limited (VRPL) is a value-based engineering and financial services company offering services for a broad spectrum of industries.</p>
          <div className="footer-logo">
            <img src={logo} alt="Vardaan Resources Logo" />
          </div>
        </div>
       
        <div className="footer-column">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/mission">Mission</Link></li>
            <li><Link to="/services">Our Services</Link></li>
            <li><Link to="/management">Management</Link></li>
            <li><Link to="/credentials">Credentials</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>
       
        <div className="footer-column">
          <h3>Services</h3>
          <div className="services-grid">
            <ul className="services-column">
              <li><Link to="/services#capitalization">Capitalization of Fixed Assets (PPE)</Link></li>
              <li><Link to="/services#business-valuations">Business and Plant Valuations</Link></li>
              <li><Link to="/services#physical-verification">Physical Verification of Fixed Assets and Inventory</Link></li>
              <li><Link to="/services#feasibility">Technical & Financial Feasibility Studies</Link></li>
              <li><Link to="/services#monitoring">Project Monitoring</Link></li>
              <li><Link to="/services#lenders">Lender's/Owner's Engineers</Link></li>
            </ul>
            <ul className="services-column">
              <li><Link to="/services#valuation">Valuation of Fixed Assets</Link></li>
              <li><Link to="/services#bul">Technical Assessment of Balance Useful Life</Link></li>
              <li><Link to="/services#impairment">Asset Impairment Studies</Link></li>
              <li><Link to="/services#consultancy">Technical and Financial Consultancy</Link></li>
              <li><Link to="/services#management">Management Services</Link></li>
              <li><Link to="/services#site-visits">Site Visits and Inspection Services</Link></li>
              <li><Link to="/epc#epc">Engineering, Procurement & Construction - Solar</Link></li>
            </ul>
          </div>
        </div>
       
        <div className="footer-column">
          <h3>Contact Us</h3>
          <div className="contact-info">
            <div className="location-item">
              <i className="fas fa-map-marker-alt"></i>
              <div className="location-text">
                <p className="company-name">Vardaan Resources Pvt. Ltd.</p>
                <p>Aurum, 1st Floor, Plot no 57,</p>
                <p>Jayabheri Enclave, Phase 2,</p>
                <p>Gachibowli, Hyderabad - 500032</p>
                <p>INDIA.</p>
              </div>
            </div>
            <p><i className="fas fa-phone"></i><span>+91 99662 22370</span></p>
            <p><i className="fas fa-envelope"></i><span>info@vardaanglobal.com</span></p>
          </div>
        </div>
      </div>
     
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Vardaan Resources Pvt. Ltd. All Rights Reserved.</p>
      </div>
    </footer>
  );
};
 
export default Footer;
 